import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

type SlideOverProps = {
  open: boolean;
  onClose: () => void;
  large: boolean;
  children: React.ReactNode;
};

const SlideOver = ({ open, onClose, large, children }: SlideOverProps) => (
  <Transition.Root show={open} as={Fragment}>
    <Dialog as="div" className="relative z-10" onClose={onClose}>
      <Transition.Child
        as={Fragment}
        enter="transition-opacity ease-in duration-[400ms]"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-in duration-[400ms]"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} />
      </Transition.Child>
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in duration-[400ms]"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in duration-[400ms]"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <div
              className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10"
              onClick={(e) => e.stopPropagation()}
            >
              <Dialog.Panel
                className={`pointer-events-auto w-screen ${large ? "max-w-3xl" : "max-w-md"}`}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="absolute top-0 left-0 flex pt-4 pr-2 sm:pr-4">
                  <button
                    type="button"
                    className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose();
                    }}
                  >
                    <span className="sr-only">Close panel</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                  {children}
                </div>
              </Dialog.Panel>
            </div>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

export default SlideOver;
